import { render, staticRenderFns } from "./LocationView.vue?vue&type=template&id=0f52a868&scoped=true"
import script from "./LocationView.vue?vue&type=script&lang=js"
export * from "./LocationView.vue?vue&type=script&lang=js"
import style0 from "./LocationView.vue?vue&type=style&index=0&id=0f52a868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f52a868",
  null
  
)

export default component.exports